import Vue from "vue";
import Router from "vue-router";
import store from "./store.js";

import Home from "./pages/index";
import Login from "./pages/login";
import Signup from "./pages/signup";
import Profile from "./pages/profile";
import PaymentV2 from "./pages/paymentV2"
import Service from "./pages/service";
import PaymentResult from "./pages/paymentResult";
import Notice from "./pages/info/notice";

import Compnay from "./pages/info/company";
import Recruit from "./pages/info/recruit";

import Term01 from "./components/terms/Term01";
import Term02 from "./components/terms/Term02";

import AnalyticsPlatform from "./pages/analyticsPlatform";

import DuplicatedLoggedin from "./pages/duplicatedLoggedin.vue";
import RichgoGuide from "./components/RichgoGuide";

import NotFoundComponent from "./pages/notFoundComponent";


// hyundai
import hyundaiLogin from "./pages/b2b/hyundai/hyundaiLogin"
import hyundaiChangePassword from "./pages/b2b/hyundai/hyundaiChangePassword"
import hyundaiProfile from "./pages/b2b/hyundai/hyundaiProfile";
import TableauComponent from "./components/b2b/hyundai/TableauComponent";
// dlcon
import dlconLogin from "./pages/b2b/dlcon/dlconLogin";
import dlconChangePassword from "./pages/b2b/dlcon/dlconChangePassword";
import dlconProfile from "./pages/b2b/dlcon/dlconProfile";
import DlconTableauComponent from "./components/b2b/hyundai/TableauComponent";
import hyundaiCreateBusinessLocation from "./pages/b2b/hyundai/hyundaiCreateBusinessLocation";
import hyundaiDeleteBusinessLocation from "./pages/b2b/hyundai/hyundaiDeleteBusinessLocation";


Vue.use(Router);

const LAST_ROUTE = "lastRoute";

export const loadToken = (to, from, next) => {
  if (to.path === "/login" && from !== null) {
    localStorage.setItem(LAST_ROUTE, from.path);
  }
  // 로그인을 새로하면 refreshToken을 발급 받는다.
  const token = to.query.refreshToken;
  if (token !== undefined) {
    store.commit("setRefreshToken", token);
    const lastRoute = localStorage.getItem(LAST_ROUTE) || "/";
    next({ path: lastRoute, replace: true });
  } else {
    if (store.state.refreshToken === "") {
      const refreshToken = localStorage.getItem("refreshToken");
      if (refreshToken) {
        store.commit("setRefreshToken", refreshToken);
      }

      const accessToken = localStorage.getItem("accessToken");
      if (accessToken) {
        store.commit("setAccessToken", accessToken);
      }
    }
    next();
  }
};

async function onlyAuthUser(to, from, next) {
  if ((await store.dispatch("updateLoggedin")) === false) {
    alert("로그인이 필요합니다.");
    next("/login");
  } else {
    next();
  }
}

async function onlyHyundaiAuthUser(to, from, next) {
  if ((await store.dispatch("updateLoggedin")) === false) {
    alert("로그인이 필요합니다.");
    next("/hyundai/login");
  } else {
    next();
  }
}

async function onlyDlconAuthUser(to, from, next) {
  if ((await store.dispatch("updateLoggedin")) === false) {
    alert("로그인이 필요합니다.");
    next("/dlcon/login");
  } else {
    next();
  }
}

async function rejectAuthUser(to, from, next) {
  if ((await store.dispatch("updateLoggedin")) === true) {
    alert("이미 로그인을 하였습니다.");
    next("/");
  } else {
    next();
  }
}

export default new Router({
  mode: "history",
  linkExactActiveClass: "active",

  routes: [
    {
      path: "/",
      name: "home",
      component: Home
    },
    {
      path: "/login",
      name: "login",
      beforeEnter: rejectAuthUser,
      component: Login
    },
    {
      path: "/signup",
      name: "signup",
      beforeEnter: rejectAuthUser,
      component: Signup
    },
    {
      path: "/info",
      name: "info",
      component: Notice
    },
    {
      path: "/info/notice",
      name: "info/notice",
      component: Notice
    },
    {
      path: "/info/company",
      name: "info/company",
      component: Compnay
    },
    {
      path: "/info/recruit",
      name: "info/recruit",
      component: Recruit
    },
    {
      path: "/service",
      name: "service",
      component: Service
    },
    {
      path: "/service/subscribe",
      name: "service/subscribe",
      beforeEnter: onlyAuthUser,
      component: PaymentV2
    },
    {
      path: "/service/payment",
      name: "service/payment",
      component: PaymentV2
    },
    {
      path: "/realestate/:tableauId?",
      props: route => ({ tableauId: route.params.tableauId || null }),
      name: "realestate",
      // beforeEnter: onlyAuthUser,
      component: AnalyticsPlatform
    },
    {
      path: "/economy/:tableauId?",
      props: route => ({ tableauId: route.params.tableauId || null }),
      name: "economy",
      // beforeEnter: onlyAuthUser,
      component: AnalyticsPlatform
    },
    {
      path: "/profile",
      name: "profile",
      beforeEnter: onlyAuthUser,
      component: Profile
    },
    {
      path: "/pricing",
      name: "pricing",
      component: PaymentV2
    },
    {
      path: "/payment",
      name: "payment",
      component: PaymentV2
    },
    {
      path: "/payment/result/:transactionId",
      props: route => ({
        transactionId: route.params.transactionId || null
      }),
      name: "paymentResult",
      beforeEnter: onlyAuthUser,
      component: PaymentResult
    },
    {
      path: "/duplicated-loggedin",
      name: "DuplicatedLoggedin",
      component: DuplicatedLoggedin
    },
    {
      path: "/richgo-guide",
      name: "RichgoGuide",
      component: RichgoGuide
    },
    {
      path: "/terms/term01",
      name: "Term01",
      component: Term01
    },
    {
      path: "/terms/term02",
      name: "Term02",
      component: Term02
    },
    {
      path: "/hyundai/login",
      name: "hyundaiLogin",
      component: hyundaiLogin
    },
    {
      path: "/hyundai/changePassword",
      name: "hyundaiChangePassword",
      component: hyundaiChangePassword,
      beforeEnter: onlyHyundaiAuthUser
    },
    {
      path: "/hyundai/profile",
      name: "hyundaiProfile",
      component: hyundaiProfile,
      beforeEnter: onlyHyundaiAuthUser
    },
    {
      path: "/hyundai/create",
      name: "hyundaiCreateBusinessLocation",
      component: hyundaiCreateBusinessLocation,
      beforeEnter: onlyHyundaiAuthUser
    },
    {
      path: "/hyundai/update/:siteId",
      name: "hyundaiDeleteBusinessLocation",
      props: route => ({
        siteId: Number.parseInt(route.params.siteId) || -1
      }),
      component: hyundaiDeleteBusinessLocation,
      beforeEnter: onlyHyundaiAuthUser
    },
    {
      path: "/hyundai/:tableauId?",
      props: route => ({ tableauId: route.params.tableauId || null }),
      name: "hyundaiTableau",
      component: TableauComponent,
      beforeEnter: async function(to, from, next) {
        if ((await store.dispatch("updateLoggedin")) === false) {
          next("/hyundai/login");
        } else {
          if (store.state.profile && store.state.profile.isHyundai !== true) {
            alert('잘못된 접근입니다. (code-2)');
            next('/');
            return;
          }

          if (to.path.endsWith('/hyundai'))
            next('/hyundai/b2b_market_trend_dashboard_01%2Fb2b_market_trend_dashboard_01_main_01');
          else
            next();
        }
      }
    },
    {
      path: "/dlcon/login",
      name: "dlconLogin",
      component: dlconLogin
    },
    {
      path: "/dlcon/changePassword",
      name: "dlconChangePassword",
      component: dlconChangePassword,
      beforeEnter: onlyDlconAuthUser
    },
    {
      path: "/dlcon/profile",
      name: "dlconProfile",
      component: dlconProfile,
      beforeEnter: onlyDlconAuthUser
    },
    {
      path: "/dlcon/:tableauId?",
      props: route => ({ tableauId: route.params.tableauId || null }),
      name: "dlconTableau",
      component: DlconTableauComponent,
      beforeEnter: async function(to, from, next) {
        if ((await store.dispatch("updateLoggedin")) === false) {
          next("/dlcon/login");
        } else {
          if (store.state.profile && store.state.profile.isDlcon !== true) {
            alert('잘못된 접근입니다. (code-2)');
            next('/');
            return;
          }

          if (to.path.endsWith('/dlcon'))
            next('/dlcon/b2b_market_trend_dashboard_01%2Fb2b_market_trend_dashboard_01_main_01');
          else
            next();
        }
      }
    },
   {
      path: "*",
      component: NotFoundComponent
    }
  ],
  scrollBehavior: to => {
    if (to.hash) {
      return { selector: to.hash };
    } else {
      return { x: 0, y: 0 };
    }
  }
});
